var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"message-marker",attrs:{"src":_vm.$publicPath + 'img/header-nav-icons/messages.svg',"width":"20"}})
}
var staticRenderFns = []

export { render, staticRenderFns }